module.exports = __webpack_public_path__ + "img/3.bf8028db.jpg";